import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";


const StockCenter = ({i, stockCenter, unlinkStockCenter, getProduct, product, getCountProducts}) => {
    let myAbilities = HelpAbility();
    let {_id, centerId, stock} = stockCenter
    let {codigoCentro, nombre, esCentro} = centerId;

    const handleUnlinkStockCenter = async () => {
     let status = await unlinkStockCenter({id: product._id, stockCenterId: _id})
     if(!status){
      await getProduct({id: product._id});
      await getCountProducts();
     }
    }
    return (
        <tr>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{codigoCentro}</td>
            <td className="text-center">{nombre}</td>
            <td className="text-center">{esCentro ? 'Centro' : 'Agente'}</td>
            <td className="text-center">{stock}</td>
            
            {myAbilities.hasAny([C.A.PRODUCT.UPDATE, C.A.CENTER.LINK]) && <td className="text-center">
                {myAbilities.has(C.A.CENTER.LINK) && <OverlayTrigger placement="top"
                                                                        overlay={<Tooltip
                                                                            id="tooltip-top">Desvincular Centro</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-danger"
                            onClick={handleUnlinkStockCenter}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>}
            </td>}
        </tr>
    );
}
export default StockCenter;
